module.exports = __webpack_public_path__ + "static/ng_group_blue_2-cd5d27a63890d54f93aed9037cbcabd7.png";